import { type EnvironmentName } from "@/models/environment.types"
import { APP_COMPANY_NAME } from "@/utils/constants"

const nzeroMailServerAndDomain = `${APP_COMPANY_NAME.toLowerCase()}.com`

const isNzeroEmail = (email: string | null | undefined): boolean => {
  return email?.endsWith(`@${nzeroMailServerAndDomain}`) ?? false
}

const createSafeSigmaEmbedUserEmail = (
  email: string,
  env: EnvironmentName
): string => {
  const emailParts = email.split("@")
  const username = emailParts[0]
  const mailServerAndDomain = emailParts[1]
  const envSuffix = env === "production" ? "" : `-${env}`

  return `${username}+sigma${envSuffix}@${mailServerAndDomain}`
}

export const getSafeSigmaEmbedUserEmail = (
  email: string | null | undefined
): string => {
  if (isNzeroEmail(email)) {
    return email
      ? createSafeSigmaEmbedUserEmail(
          email,
          (process.env.REACT_APP_ENV as EnvironmentName) ?? "local"
        )
      : ""
  }

  return email ?? ""
}
